<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        scale: {
            type: Function,
            default: () => {}
        },
        height: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            required: true,
        },
    },
})
</script>

<template>
    <g class="axis">
        <line :y2="height" stroke="black" />
        <text :x="- height / 2" :y="-15" fill="black" style="transform: rotate(270deg); text-anchor: middle; font-size: 15; shape-rendering: geometricPrecision;">
            {{ options.legend }}
        </text>
        <g v-for="(tickValue, i) of scale.ticks(Math.max(width / 80))" :key="i" :transform="`translate(0, ${scale(tickValue)})`" class="tick">
            <line :x2="6" stroke="black" />
            <line :x2="width - 25" stroke="black" style="opacity: 0.1" />
        </g>
    </g>
</template>
